module.exports = __webpack_public_path__ + "static/media/plus.accc186e.svg";